import EditorElement from './EditorElement.component';

export default EditorElement;
